import {
  REGANTO_CLASSIC_FAILED,
  REGANTO_CLASSIC_REQUEST,
  REGANTO_CLASSIC_SUCCESS,
} from "app/redux/actions/SeriesProduct/RegantoClassic/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const regantoClassicReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case REGANTO_CLASSIC_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case REGANTO_CLASSIC_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case REGANTO_CLASSIC_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
